module.exports = __webpack_public_path__ + "img/24_33.f47bd119.png";